import { createAsyncAction, action } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import { AuthTypes, AuthResponse, AuthRequestActionPayload } from './types';

const authActions = createAsyncAction(
  AuthTypes.AuthRequest,
  AuthTypes.AuthSuccess,
  AuthTypes.AuthFailure
)<AuthRequestActionPayload, AuthResponse, HttpStatus>();

export const logout = () => action(AuthTypes.Logout);

export default authActions;
